var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"message-fade"}},[(!_vm.closed)?_c('div',{class:['message', 'message-' + _vm.type, _vm.center ? 'is-center' : ''],style:({ top: _vm.offset + 'px' })},[_c('div',{staticClass:"message-content"},[_c('div',{staticClass:"img"}),_vm._v(_vm._s(_vm.message))]),_c('i',{staticClass:"icon icon-close"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }